import React from "react";

import {
  useEffect,
  useState,
} from "react";


import {
  usePrivacyContext,
} from "../context/PrivacyContext";



export function PrivacyPreferences(){


  const {

    consent,

    updateConsent,

    preferencesOpen,

    closePreferences,

    translations,

  } =
    usePrivacyContext();




  const [

    preferences,

    setPreferences

  ] =
    useState(consent);



  useEffect(() => {

    setPreferences(consent);

  }, [consent]);




  if(!preferencesOpen){

    return null;

  }




  function toggle(

    key:

    keyof typeof preferences

  ){


    if(key === "necessary"){

      return;

    }



    setPreferences({


      ...preferences,


      [key]:

        !preferences[key],


    });


  }




  function save(){


    updateConsent(

      preferences

    );


    closePreferences();


  }




  return (


    <div className="privacy-preferences">


      <div className="privacy-preferences-content">



        <h2>

          {translations.preferencesTitle}

        </h2>




        <label>


          <input

            type="checkbox"

            checked={true}

            disabled

          />


          {translations.necessaryCookies}


        </label>




        <label>


          <input

            type="checkbox"

            checked={

              preferences.analytics

            }

            onChange={() =>

              toggle("analytics")

            }

          />


          {translations.analytics}


        </label>




        <label>


          <input

            type="checkbox"

            checked={

              preferences.marketing

            }

            onChange={() =>

              toggle("marketing")

            }

          />


          {translations.marketing}


        </label>




        <label>


          <input

            type="checkbox"

            checked={

              preferences.preferences

            }

            onChange={() =>

              toggle("preferences")

            }

          />


          {translations.preferences}


        </label>




        <div className="privacy-preferences-actions">



          <button

            onClick={save}

          >

            {translations.savePreferences}


          </button>




          <button

            onClick={closePreferences}

          >

            {translations.close}


          </button>



        </div>



      </div>


    </div>


  );

}